import { clsx } from '../../../ds/clsx';
import type { FinancingRecord } from '../types';
import styles from './ui.module.css';

export interface StageBarProps {
  stageBar: FinancingRecord['stageBar'];
  lostSegment: FinancingRecord['lostSegment'];
  className?: string | undefined;
}

/**
 * The stage bar of the financing record (A2 „Stufen-Fortschrittsbalken"): six segments with 3 px bars —
 * done navy, active accent with the semibold label and its note, open sand — and „Verloren" after a hairline.
 */
export function StageBar({ stageBar, lostSegment, className }: StageBarProps) {
  return (
    <div className={clsx(styles.stageBar, className)} role="list" aria-label="Stufen">
      {stageBar.map((segment) => (
        <div
          key={segment.key}
          role="listitem"
          aria-current={segment.state === 'active' ? 'step' : undefined}
          aria-label={`${segment.label}${segment.note ? ` ${segment.note}` : ''}`}
          className={clsx(
            styles.segment,
            segment.state === 'done' && styles.done,
            segment.state === 'active' && styles.active,
          )}
        >
          <span className={styles.bar} aria-hidden="true" />
          <span className={styles.label} aria-hidden="true">
            {segment.label}
            {segment.state === 'active' && segment.note ? (
              <span className={styles.note}> {segment.note}</span>
            ) : null}
          </span>
        </div>
      ))}
      <div
        role="listitem"
        aria-current={lostSegment.active ? 'step' : undefined}
        className={clsx(styles.segment, styles.lost, lostSegment.active && styles.lostActive)}
      >
        <span className={styles.bar} aria-hidden="true" />
        <span className={styles.label}>{lostSegment.label}</span>
      </div>
    </div>
  );
}
